import React from "react";
import { CompassIcon, ClockIcon, ScaleIcon, RulerIcon, AlertTriangleIcon, StethoscopeIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { pains, PainIcon } from "../../data/content";
const iconMap: Record<PainIcon, React.ComponentType<{
  className?: string;
}>> = {
  compass: CompassIcon,
  clock: ClockIcon,
  tooth: StethoscopeIcon,
  ruler: RulerIcon,
  scale: ScaleIcon,
  alert: AlertTriangleIcon
};
export function Pains() {
  return <section className="w-full bg-[#eef4ff] px-4 py-16 sm:py-20" data-id="element-233" data-mp="2w8862ot83c4v">
      <div className="mx-auto max-w-5xl" data-id="element-234" data-mp="2w7owbvdq7u1x">
        <h2 className="text-center font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-235" data-mp="3awux3ns7psbx">Does Any of This Sound Familiar?</h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-slate-600" data-id="element-236" data-mp="35zcndv6df92v">
          If you recognize even one of these situations, I created this system with your learning needs in mind.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-237" data-mp="3fy23pjimclh0">
          {pains.map(p => {
          const Icon = iconMap[p.icon];
          return <article key={p.title} className="flex flex-col rounded-2xl bg-white p-6 shadow-[0_4px_20px_rgba(8,23,51,0.08)]" data-id="element-238" data-mp="n2ad8ex1s7qa">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy" data-id="element-239" data-mp="rz0qkuhgwp80">
                  <Icon className="h-6 w-6 text-brand" data-id="element-240" data-mp="x0q4chw2rgzs" />
                </span>
                <h3 className="mt-4 font-display text-lg font-black leading-snug text-ink" data-id="element-241" data-mp="11xqastwu6lrf">{p.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-242" data-mp="15ysa1aqr6xte">{p.text}</p>
              </article>;
        })}
        </div>

        <div className="mx-auto mt-12 max-w-3xl space-y-4 text-center text-[17px] leading-relaxed text-slate-700" data-id="element-243" data-mp="1fpn0ysey2ll6">
          <p className="font-display text-xl font-black text-ink" data-id="element-244" data-mp="1kpj28jw9byx1">And it shouldn’t have to feel so complicated.</p>
          <p data-id="element-245" data-mp="1pp5g8vjwtj6w">In my experience as an educator, understanding individual restorative concepts and organizing them into a coherent clinical plan are two different challenges.</p>
          <p data-id="element-246" data-mp="v1dptv9f0ynh">You can understand posts, cores, crowns, adhesive procedures, and ferrule principles individually. But when you’re evaluating a specific tooth, you still need to connect those concepts.</p>
          <p className="font-bold text-brand-deep" data-id="element-247" data-mp="14yi0axtwf5og">That’s the gap Post-Endodontic Restoration Blueprint™ is designed to help you address.</p>
        </div>

        <div className="mt-10" data-id="element-248" data-mp="1isj4i73mdkw7">
          <CTAButton label="I want a structured restorative planning system" data-id="element-249" data-mp="1drlmbuim0qup" />
        </div>
      </div>
    </section>;
}